import { useContext, useEffect, useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { CalendarMonth, Check, DirectionsCarOutlined } from '@mui/icons-material';

import { TabValue } from '@/types';
import { ctxRoutes } from '@/contexts/RoutesCtx.tsx';
import { useTranslation } from 'react-i18next';

import './RouteStyle.css';
import { datePeriodMD } from '@/utilities/dateUtils';

export function RoutesHeader() {
  const ctx = useContext(ctxRoutes);
  const [intervalLength, setIntervalLength] = useState<string>('');
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (ctx?.selectedDates?.from && ctx?.selectedDates.to) {
      setIntervalLength(datePeriodMD(ctx.selectedDates.from, ctx.selectedDates.to, t));
    } else {
      setIntervalLength('');
    }
  }, [ctx, i18n]);

  if (!ctx) return null;

  return (
    <>
      <Box className="route-header">
        <Tabs
          variant="fullWidth"
          textColor="secondary"
          indicatorColor="secondary"
          value={ctx.tab}
          onChange={(_evt, value) => ctx.setTab(value as TabValue)}
        >
          <Tab
            value={TabValue.targetSelect}
            sx={{ textTransform: 'none' }}
            icon={
              <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <DirectionsCarOutlined />
                {ctx.selectedTarget && (
                  <Check color="success" fontSize="medium" sx={{ position: 'absolute', right: -25 }} />
                )}
              </Box>
            }
            label={ctx.selectedTarget?.name ?? t('refuels.selectVehicle')}
            data-qa-element-id="target_selector_tab"
          />
          <Tab
            value={TabValue.dateSelect}
            icon={<CalendarMonth />}
            label={
              <div
                data-qa-element-id={`date_selector_tab_label_${ctx.selectedDates?.from.toLocaleDateString()}_${ctx.selectedDates?.to.toLocaleDateString()}`}
              >
                {intervalLength || t('refuels.period')}
              </div>
            }
            sx={{ opacity: !ctx.selectedTarget ? 0 : 1, textTransform: 'none' }}
            disabled={!ctx.selectedTarget}
            data-qa-element-id="date_selector_tab"
          />
        </Tabs>
      </Box>
    </>
  );
}
